import { jsx as p } from "react/jsx-runtime";
import { c as s } from "react/compiler-runtime";
import { Card as f } from "@mui/material";
import { forwardRef as l } from "react";
const C = l((m, i) => {
  const r = s(7);
  let o, t;
  r[0] !== m ? ({
    children: o,
    ...t
  } = m, r[0] = m, r[1] = o, r[2] = t) : (o = r[1], t = r[2]);
  let e;
  return r[3] !== o || r[4] !== t || r[5] !== i ? (e = /* @__PURE__ */ p(f, { ref: i, ...t, children: o }), r[3] = o, r[4] = t, r[5] = i, r[6] = e) : e = r[6], e;
});
export {
  C as Card
};
